import { render, staticRenderFns } from "./SlideTypeCard.vue?vue&type=template&id=3c3d4e7e&scoped=true"
import script from "./SlideTypeCard.vue?vue&type=script&lang=ts"
export * from "./SlideTypeCard.vue?vue&type=script&lang=ts"
import style0 from "./SlideTypeCard.vue?vue&type=style&index=0&id=3c3d4e7e&prod&scoped=true&lang=scss"
import style1 from "./SlideTypeCard.vue?vue&type=style&index=1&id=3c3d4e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3d4e7e",
  null
  
)

export default component.exports